import { canvasCardLabel, type ToolResult } from "@/lib/api";

// --- Types ---
export interface CanvasCard {
	id: string;
	title: string;
	icon: string;
	content: string;
	x: number;
	y: number;
	width: number;
	height: number;
}

export type ResizeDirection = "n" | "s" | "e" | "w" | "ne" | "nw" | "se" | "sw";

export type CanvasTool = "hand" | "move";

// --- Constants ---
export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 3;
export const ZOOM_SENSITIVITY = 0.005;
export const MIN_CARD_WIDTH = 200;
export const MIN_CARD_HEIGHT = 120;

const CARD_WIDTH = 500;
const CARD_HEIGHT = 500;
const CARD_GAP = 60;
const CARDS_PER_ROW = 2;
const CARD_START_X = 200;
const CARD_START_Y = 80;

/** PG `real` vs JS number: strict === often fails on posX/posY after round-trip */
const COMMENT_POS_EPS = 0.05;

export function sameCanvasPos(a: number, b: number): boolean {
	return Math.abs(a - b) < COMMENT_POS_EPS;
}

export function toolResultsToCards(results: ToolResult[]): CanvasCard[] {
	return results
		.filter((r) => r.content)
		.map((r, i) => {
			const col = i % CARDS_PER_ROW;
			const row = Math.floor(i / CARDS_PER_ROW);
			return {
				id: r.id,
				title: canvasCardLabel(r, results, i),
				icon: "📄",
				content: r.content || "",
				x: CARD_START_X + col * (CARD_WIDTH + CARD_GAP),
				y: CARD_START_Y + row * (CARD_HEIGHT + CARD_GAP),
				width: CARD_WIDTH,
				height: CARD_HEIGHT,
			};
		});
}
